import * as React from 'react';
import './ExpandableRowDesktop.scss';
import localeFormating from 'src/translation/localeFormating';
import { IReturnDetail } from 'src/services/returns/typings';
import localeFormatingInstance from 'src/translation/localeFormating';
import IconMessage from 'src/components/common/IconMessage';

interface IExpandableRowDesktopProps {
  returnDetail: IReturnDetail;
  getInvoicePreview: (invoiceNumber: number, invoiceDate: string) => void;
}

const ExpandableRowDesktop: React.FC<IExpandableRowDesktopProps> = ({
  returnDetail,
  getInvoicePreview
}) => {
  const handleInvoicePreview = (e: any) => {
    e.preventDefault();
    getInvoicePreview(
      Number(returnDetail.creditInvoice),
      String(returnDetail.invoiceDate)
    );
  };

  return (
    <div className="rp-expandable-row-desktop">
      <div className="container-fluid">
        <div className="row">
          <div className="col-2 partNumber">
            <p className="rp-expandable-row-desktop-content">
              {returnDetail.partNumber}
            </p>
          </div>
          <div className="col-1 invoiceNumber">
            <p className="rp-expandable-row-desktop-content">
              {returnDetail.invoiceNumber}
            </p>
          </div>
          <div className="col-1 invoiceDate">
            <p className="rp-expandable-row-desktop-content">
              {localeFormatingInstance.formatDate(
                returnDetail.invoiceDate,
                'short'
              )}
            </p>
          </div>
          <div className="col-1 price">
            <p className="rp-expandable-row-desktop--bold">
              {localeFormating.formatCurrency(returnDetail.price)}
              {returnDetail.hasCoreIncluded && (
                <IconMessage
                  icon={'rpds-error'}
                  isIconInline={true}
                  message={'This price includes a Core Charge'}
                />
              )}
            </p>
          </div>
          <div className="col-1 d-flex justify-content-center returnQty">
            <p className="rp-expandable-row-desktop-content">
              {returnDetail.returnQuantity}
            </p>
          </div>
          <div className="col-1 d-flex justify-content-center restockingFee">
            <p className="rp-expandable-row-desktop-content">
              {returnDetail.restockingFee}%
            </p>
          </div>
          <div className="col-2 d-flex justify-content-center creditAmount">
            <p className="rp-expandable-row-desktop--bold">
              {localeFormating.formatCurrency(returnDetail.returnAmount)}
            </p>
          </div>
          <div className="col-2 reason">
            <p className="rp-expandable-row-desktop-content">
              {returnDetail.reason}
            </p>
          </div>
          <div className="col-2 creditInvoice">
            <a
              href="#"
              onClick={handleInvoicePreview}
              className="rp-expandable-row-desktop-content link"
            >
              {returnDetail.creditInvoice}
            </a>
          </div>
          <div className="col-2 status">
            <p className="rp-expandable-row-desktop-content">
              {returnDetail.lineStatus}
            </p>
            {returnDetail.rejectionReason &&
            <p className="rp-expandable-row-desktop-content">
            (Reason - {returnDetail.rejectionReason})
          </p>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpandableRowDesktop;
